import { useState } from 'react';

/**
 * Date range filter component for analytics
 * Supports preset ranges (7d, 30d) and custom date selection
 */
export default function DateRangeFilter({
  dateRange,
  presets,
  onSelectPreset,
  onSelectCustomRange,
}) {
  const [showCustom, setShowCustom] = useState(false);
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');

  const handlePresetClick = (presetKey) => {
    setShowCustom(false);
    onSelectPreset(presetKey);
  };

  const handleCustomSubmit = (e) => {
    e.preventDefault();
    if (customStart && customEnd) {
      onSelectCustomRange(customStart, customEnd);
      setShowCustom(false);
    }
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <div className="date-range-filter">
      <div className="filter-tabs" role="group" aria-label="Seleccionar rango de fechas">
        {Object.entries(presets).map(([key, preset]) => (
          <button
            key={key}
            className={`filter-tab ${dateRange === key ? 'active' : ''}`}
            onClick={() => handlePresetClick(key)}
            aria-pressed={dateRange === key}
          >
            {preset.label}
          </button>
        ))}
        <button
          className={`filter-tab ${dateRange === 'custom' ? 'active' : ''}`}
          onClick={() => setShowCustom(!showCustom)}
          aria-pressed={dateRange === 'custom'}
          aria-expanded={showCustom}
        >
          Personalizado
        </button>
      </div>

      {showCustom && (
        <form className="custom-range-form" onSubmit={handleCustomSubmit}>
          <div className="custom-range-inputs">
            <div className="formEntry">
              <label>Desde</label>
              <input
                type="date"
                value={customStart}
                onChange={(e) => setCustomStart(e.target.value)}
                max={today}
                required
              />
            </div>
            <div className="formEntry">
              <label>Hasta</label>
              <input
                type="date"
                value={customEnd}
                onChange={(e) => setCustomEnd(e.target.value)}
                min={customStart}
                max={today}
                required
              />
            </div>
            <button type="submit" className="apply-btn">
              Aplicar
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
